( function( $ ) {

	$( '.sims-tabs-tab' ).on( 'click', function () {

		const hiddenTab = $( this )
		const hiddenPanel = $( `#${ hiddenTab.attr( 'aria-controls' ) }` )

		const section = hiddenTab.closest( '.sims-tabs' )

		const shownTab = $( section ).find( '.sims-tabs-tab[aria-selected="true"]' )
		const shownPanel = $( section ).find( '.sims-tabs-panel[aria-hidden="false"]' )

		hiddenPanel.attr( 'aria-hidden', 'false' )
		shownPanel.attr( 'aria-hidden', 'true' )

		hiddenTab.attr( 'aria-selected', 'true' )
		shownTab.attr( 'aria-selected', 'false' )

	} )

} )( jQuery )
